import Vue from 'vue';
import Router from 'vue-router';

import Home from '~components/Home';
import Contact from '~components/Contact';
import Rules from '~components/Rules';
import Bio from '~components/Bio';

import ChoiceCharacter from '~components/choice-character/ChoiceCharacter';
import ChoiceCharacterSlide from '~components/choice-character/ChoiceCharacterSlide';
import ChoiceCharacterValidate from '~components/choice-character/ChoiceCharacterValidate';

import Game from '~components/game/Game';
import End from '~components/game/End';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Home,
      name: 'home',
    },
    {
      path: '/choisir-son-personnage',
      component: ChoiceCharacter,
      name: 'choice-charac-all',
    },
    {
      path: '/choisir-son-personnage-slide',
      component: ChoiceCharacterSlide,
      name: 'choice-charac-slide',
    },
    {
      path: '/valider-son-personnage',
      component: ChoiceCharacterValidate,
      name: 'choice-charac-validate',
    },
    {
      path: '/jeu',
      component: Game,
      name: 'aventure',
    },
    {
      path: '/contact',
      component: Contact,
      name: 'contact',
    },
    {
      path: '/reglement',
      component: Rules,
      name: 'reglement',
    },
    {
      path: '/biographies',
      component: Bio,
      name: 'biographies',
    },
    {
      path: '/the-end',
      component: End,
      name: 'end',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js